module.exports = __webpack_public_path__ + "img/Chest-Nut-Tree-Trekking.caba1289.jpg";